import React from "react";
import { Provider } from "react-redux";
import RoutesConfig from "./routes";
import { AuthProvider } from "./Provider/AuthProvider";
import { GlobalProvider } from "./utils/GlobalContext";
import { store } from "./store/store";
import "leaflet/dist/leaflet.css";


const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <GlobalProvider>
          <RoutesConfig />
        </GlobalProvider>
      </AuthProvider>
    </Provider>
  );
};

export default App;
